import React from 'react';
import DownloadButton from '../components/uploads/DownloadButton';
// import DownloadButton from './components/DownloadButton';

function DownloadFireFiles() {
  return (
    <div>
      <h1>Firebase Storage Folder Download</h1>
      {/* Example usage: Download the folder named 'images' */}
      <DownloadButton folderPath="settings" />
    </div>
  );
}

export default DownloadFireFiles;
